module.exports = __webpack_public_path__ + "static/media/gas-pump-slash.7b2c1975.svg";